import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { NonCertifiedCheckSheetAssignment } from '@completion/services';
import {
  ChecksheetAssignmentsTableComponent,
  ChecksheetAssignment,
  AssignmentNavigationEvent,
} from '../../../shared/checksheet-assignments-table';

interface NonCertifiedAssignmentsDialogData {
  cpNumber: string;
  rows: NonCertifiedCheckSheetAssignment[];
}

@Component({
  selector: 'app-non-certified-assignments-dialog',
  standalone: true,
  imports: [CommonModule, ButtonModule, ChecksheetAssignmentsTableComponent],
  templateUrl: './non-certified-assignments-dialog.component.html',
  styleUrls: ['./non-certified-assignments-dialog.component.scss'],
})
export class NonCertifiedAssignmentsDialogComponent {
  displayColumns = [
    'cpNumber',
    'mcpNumber',
    'tagNumber',
    'checksheetNumber',
    'checksheetType',
    'status',
    'siteNumber',
    'companyNumber',
    'phaseNumber',
    'missingCertificates',
  ];

  constructor(
    private readonly router: Router,
    public readonly dialogRef: MatDialogRef<NonCertifiedAssignmentsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: NonCertifiedAssignmentsDialogData,
  ) {}

  get rowCount(): number {
    return this.data?.rows?.length ?? 0;
  }

  get assignmentData(): ChecksheetAssignment[] {
    return (this.data?.rows ?? []).map((row) => ({
      id: row.id,
      cpId: row.cpId,
      mcpId: row.mcpId,
      cpNumber: row.commissioningPackageNumber,
      mcpNumber: row.mcPackageNumber,
      tagNumber: row.tagNumber,
      checksheetId: row.id,
      checksheetNumber: row.checkSheetNumber,
      checksheetType: row.checkSheetType,
      status: row.status,
      siteNumber: row.siteNumber,
      companyNumber: row.companyNumber,
      phaseNumber: row.phaseNumber,
      missingMcc: row.missingMcc,
      missingRfcc: row.missingRfcc,
      missingRfoc: row.missingRfoc,
    }));
  }

  onAssignmentNavigation(event: AssignmentNavigationEvent): void {
    const assignment = event.assignment;
    const row = this.data.rows.find((r) => r.id === assignment.id);
    if (!row) return;

    switch (event.type) {
      case 'cp':
        this.navToCp(row);
        break;
      case 'mcp':
        this.navToMcp(row);
        break;
      case 'checksheet':
        this.navToCsa(row);
        break;
    }
  }

  navToCp(row: NonCertifiedCheckSheetAssignment): void {
    if (!row.cpId) return;
    this.router.navigate([`/cp/${row.cpId}`]);
    this.close();
  }

  navToMcp(row: NonCertifiedCheckSheetAssignment): void {
    if (!row.cpId || !row.mcpId) return;
    this.router.navigate([`/cp/${row.cpId}/mcp/${row.mcpId}`]);
    this.close();
  }

  navToCsa(row: NonCertifiedCheckSheetAssignment): void {
    if (!row.cpId || !row.id) return;
    if (row.checkSheetType === 'MC' && row.mcpId) {
      this.router.navigate([`/cp/${row.cpId}/mcp/${row.mcpId}/checksheet/${row.id}`]);
    } else {
      this.router.navigate([`/cp/${row.cpId}/checksheet/${row.id}`]);
    }
    this.close();
  }

  close(): void {
    this.dialogRef.close();
  }
}
